import { useUpsertServiceTicketMutation } from '@/store/api/services/operations/serviceTickets/index';
import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';
import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import toast from 'react-hot-toast';

const CloseServiceTicket = ({ hide, props }: ModalChildrenProps) => {
  const [updateServiceTicket, { isLoading }] = useUpsertServiceTicketMutation();

  const handleCloseTicket = async () => {
    const serviceTicketId = props?.serviceTicketData?.id;
    if (!serviceTicketId) {
      toast.error('Service ticket ID is required');
      return;
    }

    try {
      // Get current service ticket data
      const currentTicket = props?.serviceTicketData;

      // Update status to 'completed' (or 'cancelled' if needed)
      await updateServiceTicket({
        id: serviceTicketId,
        status: 'completed',
        case_id: currentTicket?.case_id || '',
        location_id: currentTicket?.location_id,
        task_types: currentTicket?.task_types || [],
        start_date: currentTicket?.start_date || new Date().toISOString(),
        technician_id: currentTicket?.technician_id ? Number(currentTicket.technician_id) : 0,
        details: currentTicket?.details || currentTicket?.description || '',
        priority: currentTicket?.priority || 'low',
        service_window: currentTicket?.service_window || '',
      }).unwrap();

      toast.success('Service ticket closed successfully');
      hide();
    } catch (error: any) {
      const errorMessage =
        error?.meta?.message ||
        error?.data?.message ||
        error?.message ||
        'Failed to close service ticket';
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <DialogContent sx={{ my: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          Are you sure you want to close service ticket {props?.serviceTicketData?.id}?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
        <Button variant="text" onClick={hide} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCloseTicket}
          disabled={isLoading}
        >
          {isLoading ? 'Closing...' : 'Yes, close ticket'}
        </Button>
      </DialogActions>
    </>
  );
};

export default CloseServiceTicket;
